import { render, staticRenderFns } from "./BaseDraggable.vue?vue&type=template&id=0be4f7f7"
import script from "./BaseDraggable.vue?vue&type=script&lang=js"
export * from "./BaseDraggable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports